export default __webpack_public_path__ + "static/media/eye.b78ca1ba.svg";